import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-warning',
  templateUrl: './warning.component.html',
  styleUrls: ['./warning.component.scss'],
  standalone: false
})
export class WarningComponent implements OnInit {

  message: string;
  errors: string[] = [];
  notes: string[] = [];

  constructor(
    public dialogRef: MatDialogRef<WarningComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.message = this.data.message || '';
    this.errors = (this.data.response || []).filter(error => !!error);
    this.notes = (this.data.notes || []).filter(note => !!note);
  }

  ok() {
    this.dialogRef.close();
  }

}
